import { MinerSortFields } from "../useMinersTableControl";

export enum MinersTableHeaderId {
  ID = 1,
  ALGO = 2,
  SPEED_D = 3,
  SPEED_C = 4,
  POOL = 5,
  STATE = 6,
  CUSTOMER = 7,
  TYPE = 8,
  LOCATIONS = 9,
}

const minerTableHeaders = [
  {
    id : MinersTableHeaderId.ID,
    messageId: "machines.table.id",
    sort: MinerSortFields.ID,
    width: 80,
    height: 100,
  },
  {
    id : MinersTableHeaderId.TYPE,
    messageId: "machines.table.type",
    sort: MinerSortFields.TYPE,
    width: 100,
    height: 300,
  },
  {
    id : MinersTableHeaderId.ALGO,
    messageId: "machines.table.algo",
    sort: MinerSortFields.ALGO,
    width: 100,
    height: 150,
  },
  {
    id : MinersTableHeaderId.SPEED_D,
    messageId: "machines.table.speed_default",
    sort: MinerSortFields.SPEED_D,
    width: 100,
    height: 100,
  },
  {
    id : MinersTableHeaderId.SPEED_C,
    messageId: "machines.table.speed_current",
    sort: MinerSortFields.SPEED_C,
    width: 100,
    height: 100,
  },
  {
    id : MinersTableHeaderId.POOL,
    messageId: "machines.table.pool_settings",
    sort: MinerSortFields.POOL,
    width: 100,
    height: 200,
  },
  {
    id : MinersTableHeaderId.STATE,
    messageId: "machines.table.state",
    sort: MinerSortFields.STATE,
    width: 50,
    height: 150,
  },
  {
    id : MinersTableHeaderId.LOCATIONS,
    messageId: "machines.table.locations",
    width: 80,
    height: 100,
  },
  {
    id : MinersTableHeaderId.CUSTOMER,
    messageId: "machines.table.customer",
    sort: MinerSortFields.CUSTOMER,
    width: 120,
    height: 380,
  },
];

export default minerTableHeaders;